import React, { Component } from 'react';

import './style.css';

class ContentLine extends Component {
  constructor(props) {
    super(props);
    this.lineRef = React.createRef();
  }
  getContent = () => {
    return this.lineRef.current.innerHTML;
  }
  setContent = content => {
    this.lineRef.current.innerHTML = content;
  }
  getLinePosition = () => {
    let r = getSelection().getRangeAt(0);
    let s = document.createElement('span');
    r.insertNode(s);
    let top = ((s.offsetTop - s.parentNode.offsetTop) === 0)
    let bottom = ((s.offsetTop - s.parentElement.offsetTop + s.offsetHeight) >= s.parentElement.offsetHeight)
    s.parentNode.removeChild(s)
    return {top, bottom};
  }
  componentDidMount() {
    let el = this.lineRef.current;
    this.setContent(this.props.content);
    el.addEventListener('paste', this.handlePaste);
    el.addEventListener('keydown', e => {
      let content = this.getContent();
      let sel = document.getSelection();
      if (content === '' && (e.key === 'Backspace')) {
        this.props.deleteParagraph();
        return e.preventDefault();
      }
      if (sel.focusOffset === 0 && e.key === 'Backspace') {
        this.props.deleteParagraph(content)
        return e.preventDefault();
      }
      if (sel.focusOffset === content.length && e.key === 'Delete') {
        this.props.mergeNextParagraph();
        return e.preventDefault();
      }
      if (e.key === 'ArrowUp') {
        if (this.getLinePosition().top) {
          this.props.moveUp();
          return e.preventDefault();
        }
      }
      if (e.key === 'ArrowDown') {
        if (this.getLinePosition().bottom) {
          this.props.moveDown();
          return e.preventDefault();
        }
      }
    })
    el.addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        let sel = document.getSelection();
        let [current, next] = [this.getContent(), ''];
        if (sel.focusOffset !== el.innerHTML.length) {
          let sep = sel.focusOffset;
          [current, next] = [current.slice(0, sep), current.slice(sep)];
        }
        this.props.onContentChange(current);
        // get focus here?
        this.props.insertParagraphAfter(next);
      }
    })
    el.addEventListener('input', e => {
      setTimeout(() => {
        this.props.onContentChange(this.getContent());
      }, 0)
    });
  }
  handlePaste = e => {
    e.preventDefault();
    let clipboardData = e.clipboardData || window.clipboardData;
    let pastedData = clipboardData.getData('text');
    document.execCommand('insertText', false, pastedData);
  }
  render() {
    return (
      <div contentEditable={true} ref={this.lineRef} className="contentLine" />
    );
  }
  componentDidUpdate(prevProps) {
    if (this.getContent() !== this.props.content) {
      this.setContent(this.props.content);
    }
  }
}

class Editor extends Component {
  state = {
    lines: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris cursus euismod nulla. Vivamus consectetur quis nisi et sollicitudin. Aliquam pharetra enim ligula, semper euismod lorem iaculis ut. Sed accumsan vol, ornare non tellus aliquet, mattis eleifend lectus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Praesent convallis egestas orci, rhoncus convallis leo imperdiet quis.',
      'Maecenas faucibus feugiat enim in elementum. Cras ultrices euismod leo vitae elementum. Mauris ac sapien et lorem rutrum tempor at eget nulla. Maecenas non dignissim justo. Suspendisse placerat, eros et maximus a sed porta finibus, turpis lorem gravida diam, vitae tempor libero ex id arcu. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nulla non lorem luctus, ultricies ipsum vel, accumsan mauris.',
      'Aenean ac ipsum orci. Donec dapibus tortor eget justo placerat, et volutpat leo accumsan. Morbi bibendum, arcu et lacinia varius, arcu ex tempor ipsum, at pharetra libero lorem non dui. Cras auctor consequat lacu.'
    ],
  }
  constructor(props) {
    super(props);
    this.editor = React.createRef();
  }
  updateContent = (c, i) => {
    let lines = this.state.lines;
    lines[i] = c;
    this.setState({lines});
  }
  focusLine = (line, char) => {
    let el = this.editor.current.children[line];
    el.focus();
    if (char) {
      if (char === Infinity) char = el.innerHTML.length;
      if (char === 0) return;
      let sel = document.getSelection();
      sel.collapse(el.firstChild, char);
    }
  }
  addLine = (index, content) => {
    let lines = this.state.lines;
    lines.splice(index, 0, content || '');
    this.setState({lines});
    this.focusLine(index);
  }
  mergeNext = index => {
    let lines = this.state.lines;
    let initLength = lines[index].length;
    if(index+1 === lines.length) return;
    let nextLine = lines[index+1];
    lines[index] = lines[index].concat(nextLine);
    lines.splice(index+1, 1);
    this.setState({lines});
    this.focusLine(index, initLength);
  }
  deleteLine = (index, content) => {
    let lines = this.state.lines;
    if (index === 0) return;
    let prevLine = lines[index-1];
    let initLength = prevLine.length;
    if (content) lines[index-1] = prevLine.concat(content);
    lines.splice(index, 1);
    this.setState({lines});
    this.focusLine(index === 0 ? 0 : index-1, initLength);
  }
  moveUp = (index, position) => {
    if (index === 0) return;
    this.focusLine(index-1);
  }
  moveDown = (index, position) => {
    if (index+1 === this.state.lines.length) return;
    this.focusLine(index+1);
  }
  addLineAtEnd = () => {
    this.addLine(this.state.lines.length);
  }
  embolden = () => {
    document.execCommand('bold')
  }
  linken = () => {
    document.execCommand('createLink', true, 'https://google.com')
  }
  render() {
    return (
      <div>
        {/* <button onClick={this.embolden}>Bold</button>
        <button onClick={this.linken}>Link</button> */}
        <div ref={this.editor}>
          {this.state.lines.map((l, i) => (
            <ContentLine 
              content={l} 
              onContentChange={c => this.updateContent(c, i)}
              insertParagraphAfter={next=>this.addLine(i+1, next)}
              deleteParagraph={content=>this.deleteLine(i, content)}
              mergeNextParagraph={()=>this.mergeNext(i)}
              moveUp={pos => this.moveUp(i, pos)}
              moveDown={pos => this.moveDown(i, pos)}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default Editor;